import ServicePage from "@/components/ServicePage";

export default function NonRunnerTransport() {
  return (
    <ServicePage
      slug="non-runner-transport"
      testid="page-non-runner-transport"
      title="Non-Runner Car Transport UK | Winch Loading | MHJ Prestige Transport"
      metaDescription="Non-runner and non-starter car transport across the UK. Winch loading, flatbeds and enclosed transporters. Get an instant online quote in seconds."
      h1="Non-runner car transport, done properly"
      intro="Won't start, no keys, flat battery, seized engine or damaged running gear — we lift, winch and load non-running vehicles safely for transport anywhere in the UK."
      heroImage="https://customer-assets.emergentagent.com/job_transport-hub-345/artifacts/3n3iv3ni_Screenshot_20260609_112234_Gallery.jpg"
      bullets={[
        "Winch-equipped flatbeds for non-starters and no-keys vehicles",
        "Slidebed and tilt-and-load transporters for lowered or damaged cars",
        "Seized-brake and no-steer vehicles handled with skates and dollies",
        "Auction site collections (Copart, IAAI, Manheim) covered daily",
        "Photographic condition report at collection",
        "Instant online quote — pay a 30% deposit, balance on delivery",
      ]}
      sections={[
        {
          title: "What counts as a non-runner?",
          body: (
            <>
              <p>
                Any vehicle that can&rsquo;t drive under its own power on and off the trailer counts as a
                non-runner: flat battery, seized engine, blown clutch, no keys, missing ECU, brakes
                locked, gearbox failure, damaged suspension — even fire-damaged shells.
              </p>
              <p>
                Just tell us the condition in your quote request and we&rsquo;ll price it accordingly. We
                don&rsquo;t add mystery surcharges after collection.
              </p>
            </>
          ),
        },
        {
          title: "Auction collections",
          body: (
            <p>
              We collect from all major UK auction sites including Copart, IAAI and Manheim, and
              handle the paperwork and gate-pass process for you. Give us the auction reference and
              lot number and we&rsquo;ll take it from there.
            </p>
          ),
        },
      ]}
      faq={[
        {
          q: "Do you charge extra for non-runners?",
          a: "A small non-runner surcharge is included in our instant quote — no hidden fees on collection.",
        },
        {
          q: "Can you collect from a Copart or IAAI site?",
          a: "Yes, we do daily auction runs across the UK. Provide your buyer reference and lot number with the booking.",
        },
        {
          q: "My car has no wheels — can you still move it?",
          a: "Yes. We use skates, dollies and slidebeds for vehicles with damaged running gear. Please describe the condition when quoting.",
        },
        {
          q: "How is the balance paid?",
          a: "The 30% deposit is via Stripe when you book. The balance is paid on delivery via bank transfer or card.",
        },
      ]}
    />
  );
}
